import { get } from "lodash";
import curryConnector from "utils/connectors";

export const EXTERNAL_LINK_TEMPLATE_STATE_KEY = "externalLinkTemplate";

const curry = fn => curryConnector(fn, EXTERNAL_LINK_TEMPLATE_STATE_KEY);

export const ActionTypes = {
  SET_EXTERNAL_LINK_TEMPLATE_FORM_DISABLED: "SET_EXTERNAL_LINK_TEMPLATE_FORM_DISABLED",

  LOADING_EXTERNAL_LINK_TEMPLATE: "LOADING_EXTERNAL_LINK_TEMPLATE",
  LOADED_EXTERNAL_LINK_TEMPLATE: "LOADED_EXTERNAL_LINK_TEMPLATE",
  ERROR_LOADING_EXTERNAL_LINK_TEMPLATE: "ERROR_LOADING_EXTERNAL_LINK_TEMPLATE",
  SAVING_EXTERNAL_LINK_TEMPLATE: "SAVING_EXTERNAL_LINK_TEMPLATE",
  SAVED_EXTERNAL_LINK_TEMPLATE: "SAVED_EXTERNAL_LINK_TEMPLATE",
  ERROR_SAVING_EXTERNAL_LINK_TEMPLATE: "ERROR_SAVING_EXTERNAL_LINK_TEMPLATE",
};

const INITIAL_STATE = {
  loading: false,
  loaded: false,
  error: null,
  formDisabled: true,
  externalLinkTemplates: [],
};

export const isExternalLinksLoading = curry(({ localState }) => get(localState, ["loading"], false));

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ActionTypes.SET_EXTERNAL_LINK_TEMPLATE_FORM_DISABLED:
      return {
        ...state,
        formDisabled: action.payload.disabled,
      };
    case ActionTypes.LOADING_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionTypes.LOADED_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        externalLinkTemplates: action.payload.externalLinkTemplates || [],
      };
    case ActionTypes.ERROR_LOADING_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    case ActionTypes.SAVING_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ActionTypes.SAVED_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
      };
    case ActionTypes.ERROR_SAVING_EXTERNAL_LINK_TEMPLATE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export const isFormDisabled = curry(({ localState }) => get(localState, ["formDisabled"], true));

export const getExternalLinkTemplates = curry(({ localState }) => get(localState, ["externalLinkTemplates"], []));
